import React, { useContext, ReactNode } from 'react';
import { Box } from 'braid-design-system';

import * as styles from '../MenuGroup.css';
import MenuContext from './Context';

type Props = {
  children: ReactNode;
};

const Content = ({ children }: Props) => {
  const { isExpanded } = useContext(MenuContext);

  if (!isExpanded) {
    return null;
  }

  return <Box className={styles.menuGroupContainer}>{children}</Box>;
};

export default Content;
